import React, { useState, useEffect } from 'react';
import '../../styles/EduComponents/FeaturesSection.css';
import { FaCalendarAlt, FaBell, FaBookOpen, FaBrain, FaChartBar, FaMoneyBillWave } from 'react-icons/fa';

const features = [
  {
    icon: <FaCalendarAlt />,
    title: "Automatically Logged Attendance",
    description: "This frees you from manual record-keeping.",
  },
  {
    icon: <FaBell />,
    title: "Automatic Timely Reminders",
    description: "Ensuring everyone stays informed without your direct intervention.",
  },
  {
    icon: <FaBookOpen />,
    title: "Standardized Curriculum Delivery",
    description: "Guaranteeing consistent, high-quality instruction across all classes.",
  },
  {
    icon: <FaBrain />,
    title: "Intuitive Lesson Planning",
    description: "Leveraging past class data to create engaging and effective future lessons.",
  },
  {
    icon: <FaChartBar />,
    title: "Instant Insightful Progress Reports",
    description: "Providing parents with valuable updates on their child's learning journey.",
  },
  {
    icon: <FaMoneyBillWave />,
    title: "Seamless Payments Collection",
    description: "Ensuring financial stability without awkward conversations.",
  },
];

const FeaturesSection = () => {
  
  const handleClick = () => {
    const tidycalUrl = process.env.REACT_APP_TIDYCAL_URL;

    try {
      // OPEN IN SAME TAB — required for redirect to work
      window.location.href = tidycalUrl;
    } catch (error) {
      console.error('Error opening TidyCal booking page:', error);
      alert('An error occurred while trying to open the booking page. Please try again later.');
    }
  };

  return (
    <section className="features-section">
      <h2>What sets <span className="highlight">Strawket</span> apart?</h2>
      <p className="subheading">Effortlessly Manage your academy and focus on Teaching</p>
      <div className="features-grid">
        {features.map((feature, index) => (
          <div key={index} className="feature-card">
            <div className="icon">{feature.icon}</div>
            <h3>{feature.title}</h3>
            <p>{feature.description}</p>
          </div>
        ))}
      </div>
      <div className="demo-button-container">
      <button onClick={handleClick} className="demo-btn5">Book A Demo</button>
      </div>
    </section>
  );
};

export default FeaturesSection;
